import * as React from 'react';
import {Player} from '@lottiefiles/react-lottie-player';
import animation from '../../../assets/animation.json';
import theme from './theme.module.scss';

export default function MainLoader(): React.JSX.Element {
    return (
        <div className={theme.container}>
            <Player
                autoplay
                loop
                src={animation}
                style={{width: '200px', height: '200px'}}
            />
        </div>
    );
}
